/*
 * Project: BookingEngine
 * Module: components/booking/extras/ExtraTransfer.js
 * vim:ft=javascript.jsx:
 */

import '../../../static/less/global/customAnimations.less';

import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import formatCurrency from 'format-currency';
import { formatDate } from 'bookingform';
import { DEVICES, getAirlines } from '../../../actions/Booking';
import { getLangValue } from '../../../utils/Generic';
import PaxSelector from './PaxSelector';
import TimePicker from '../../common/TimePicker';
import {
  EXTRA_OPTIONAL_FIELDS, EXTRA_ARRIVAL_OR_DEPARTURE_DATE, CALL_CENTER_ROLE,
} from '../../../constants';
import { addSelectedExtrasToCart } from '../../../actions/Cart';
import { removeFreeModeExtra } from '../../../actions/FreeModeCart';
import Btn from '../../ds/atoms/btn/base';
import { LOYALTY_STATUS } from '../../../actions/Loyalty';

const DATE_MASK = 'YYYY-MM-DD';
const DATE_MASK_PRINT = 'DD/MM/YYYY';

// Si el nombre de la aerolínea elegida contiene cualquiera de estas palabras,
// mostramos el input de texto libre para que el usuario escriba el nombre real.
const OTHER_AIRLINE_KEYWORDS = ['OTRA', 'OTHER'];

class ExtraTransfer extends React.Component {
  constructor(props) {
    super(props);

    const roomUse = props.cart.cartHotel.rooms[props.roomId - 1].use_alt;
    const dateCheckInCheckOut = props.extra.type[0].type_extra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOHOTEL
      ? props.checkIn : props.checkOut;

    this.state = {
      animateRoom: false,
      isSelectedExtra: false,
      oneway: {
        airline: '',
        airline_id: null,
        flight: '',
        selectedTime: {
          hour: { name: '00', code: '00' },
          minute: { name: '00', code: '00' },
          timeFormat: { name: 'am', code: 'am' },
        },
        dateSelected: moment(dateCheckInCheckOut),
      },
      roundtrip: {
        arrival_airline: '',
        arrival_airline_id: null,
        arrival_flight: '',
        arrival_selectedTime: {
          hour: { name: '00', code: '00' },
          minute: { name: '00', code: '00' },
          timeFormat: { name: 'am', code: 'am' },
        },
        arrival_dateSelected: moment(props.checkIn),
        departure_airline: '',
        departure_airline_id: null,
        departure_flight: '',
        departure_selectedTime: {
          hour: { name: '00', code: '00' },
          minute: { name: '00', code: '00' },
          timeFormat: { name: 'am', code: 'am' },
        },
        departure_dateSelected: moment(props.checkOut),
      },
      paxSelected: {
        adults: roomUse.adults,
        childs: roomUse.children,
        infants: roomUse.infants,
      },
      rooms: props.cart.cartHotel.rooms,
      typeExtra: props.extra.type[0].type_extra,
      airlinesCatalog: [],
      airlinesLoading: true,
    };
    this.updateAirline = this.updateAirline.bind(this);
    this.updateAirlineSelect = this.updateAirlineSelect.bind(this);
    this.updateFlight = this.updateFlight.bind(this);
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.onDateChanged = this.onDateChanged.bind(this);
    this.paxUpdated = this.paxUpdated.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(getAirlines())
      .then((airlines) => {
        this.setState({ airlinesCatalog: airlines, airlinesLoading: false });
      })
      .catch(() => {
        this.setState({ airlinesCatalog: [], airlinesLoading: false });
      });
  }

  componentDidUpdate() {
    if (this.state.isSelectedExtra) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isSelectedExtra: false });
    }
  }

  isAdded() {
    const { extra, cart, roomId } = this.props;
    return cart.cartHotel.rooms[roomId - 1].extras.some(
      (extraAdded) => extraAdded.code === extra.extra_code,
    );
  }

  formatDaysParam() {
    const { typeTransfer } = this.props;
    const { oneway, roundtrip } = this.state;
    const arrayDate = [];
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      arrayDate.push(oneway.dateSelected.format(DATE_MASK));
    }
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ROUNDTRIP) {
      arrayDate.push(roundtrip.arrival_dateSelected.format(DATE_MASK));
    }
    return arrayDate;
  }

  formExtraFields() {
    const {
      oneway: oneWaySelected,
      roundtrip: roundtripSelected,
      paxSelected,
    } = this.state;
    const { typeTransfer } = this.props;
    const oneway = {};

    const paxselector = {
      adults: paxSelected.adults,
      children: paxSelected.childs,
      infants: paxSelected.infants,
    };

    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      const { hour: hourOneWay, minute: minuteOneWay, timeFormat: timeFormatOneWay } = oneWaySelected.selectedTime;
      const isOnewayArrival = this.state.typeExtra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOHOTEL;
      const oneWayPickupTime = this.getPickupTime(oneWaySelected.selectedTime, isOnewayArrival);
      oneway.airline = oneWaySelected.airline;
      oneway.airline_id = oneWaySelected.airline_id;
      oneway.flight = oneWaySelected.flight;
      oneway.timepicker = `${hourOneWay.code}:${minuteOneWay.code} ${timeFormatOneWay.code}`;
      oneway.datepicker = oneWaySelected.dateSelected.format(DATE_MASK);
      const {
        hour: pickupHour,
        minute: pickupMinute,
        timeFormat: pickupTimeFormat,
      } = oneWayPickupTime;
      oneway.pickupTimepicker = `${pickupHour.code}:${pickupMinute.code} ${pickupTimeFormat.code}`;
      return { oneway, paxselector };
    }

    const roundtrip = {};
    roundtrip.arrival = {};
    roundtrip.departure = {};
    const {
      hour: arrivalHour, minute: arrivalMinute, timeFormat: arrivalTimeFormat,
    } = roundtripSelected.arrival_selectedTime;
    const {
      hour: departureHour, minute: departureMinute, timeFormat: departureTimeFormat,
    } = roundtripSelected.departure_selectedTime;
    const arrivalPickupTime = this.getPickupTime(roundtripSelected.arrival_selectedTime, true);
    const departurePickupTime = this.getPickupTime(roundtripSelected.departure_selectedTime, false);

    roundtrip.arrival.airline = roundtripSelected.arrival_airline;
    roundtrip.arrival.airline_id = roundtripSelected.arrival_airline_id;
    roundtrip.arrival.flight = roundtripSelected.arrival_flight;
    roundtrip.arrival.timepicker = `${arrivalHour.code}:${arrivalMinute.code} ${arrivalTimeFormat.code}`;
    roundtrip.arrival.datepicker = roundtripSelected.arrival_dateSelected.format(DATE_MASK);

    const {
      hour: arrPickupHour,
      minute: arrPickupMinute,
      timeFormat: arrPickupTimeFormat,
    } = arrivalPickupTime;
    roundtrip.arrival.pickupTimepicker = `${arrPickupHour.code}:${arrPickupMinute.code} ${arrPickupTimeFormat.code}`;
    roundtrip.departure.airline = roundtripSelected.departure_airline;
    roundtrip.departure.airline_id = roundtripSelected.departure_airline_id;
    roundtrip.departure.flight = roundtripSelected.departure_flight;
    roundtrip.departure.timepicker = `${departureHour.code}:${departureMinute.code} ${departureTimeFormat.code}`;
    roundtrip.departure.datepicker = roundtripSelected.departure_dateSelected.format(DATE_MASK);
    const {
      hour: depPickupHour,
      minute: depPickupMinute,
      timeFormat: depPickupTimeFormat,
    } = departurePickupTime;
    roundtrip.departure.pickupTimepicker = `${depPickupHour.code}:${depPickupMinute.code} ${depPickupTimeFormat.code}`;

    return { roundtrip, paxselector };
  }

  getExtraName(extra) {
    const extraName = getLangValue(extra, this.props.lang, 'title');
    return extraName.toLowerCase();
  }

  getExtraDescription(extra) {
    const extraDescription = getLangValue(extra, this.props.lang, 'description');
    return extraDescription;
  }

  paxUpdated(key, value) {
    const { paxSelected } = this.state;
    paxSelected[key] = value;
    this.setState({ paxSelected });
  }

  updateAirline(ev, destination, typeTransfer) {
    const airline = ev.target.value.toUpperCase();
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      this.setState({
        oneway: {
          ...this.state.oneway,
          airline,
        },
      });
    } else {
      const { roundtrip } = this.state;
      roundtrip[`${destination}airline`] = airline;
      this.setState({
        roundtrip,
      });
    }
  }

  // An airline is the catch-all "OTRA / OTHER" catalog entry if its name contains
  // either word. In that case we ask the user to type the real airline name.
  isOtherAirline(airlineName) {
    if (!airlineName) {
      return false;
    }
    const upperName = airlineName.toUpperCase();
    return OTHER_AIRLINE_KEYWORDS.some((keyword) => upperName.includes(keyword));
  }

  updateAirlineSelect(ev, destination, typeTransfer) {
    const { airlinesCatalog } = this.state;
    const selectedId = ev.target.value;
    const selectedAirline = airlinesCatalog.find((airline) => String(airline.id) === selectedId);
    const airlineIdValue = selectedAirline ? selectedAirline.id : null;
    const isOther = this.isOtherAirline(selectedAirline ? selectedAirline.name : '');
    // When the picked airline is the catalog's "OTRA/OTHER" entry, we clear the name so
    // the user is forced to type the real one in the text input we show right below.
    // Otherwise the name is exactly the catalog name, no free typing needed.
    const airlineValue = isOther ? '' : (selectedAirline ? selectedAirline.name : '');

    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      this.setState({
        oneway: {
          ...this.state.oneway,
          airline_id: airlineIdValue,
          airline: airlineValue,
        },
      });
    } else {
      const { roundtrip } = this.state;
      roundtrip[`${destination}airline_id`] = airlineIdValue;
      roundtrip[`${destination}airline`] = airlineValue;
      this.setState({
        roundtrip,
      });
    }
  }

  updateFlight(ev, destination, typeTransfer) {
    const flight = ev.target.value.toUpperCase();
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      this.setState({
        oneway: {
          ...this.state.oneway,
          flight,
        },
      });
    } else {
      const { roundtrip } = this.state;
      roundtrip[`${destination}flight`] = flight;
      this.setState({
        roundtrip,
      });
    }
  }

  onChangeSelect(selectName, selectItem, destination, typeTransfer, timeKey = 'selectedTime') {
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      const updatedTime = { ...this.state.oneway[timeKey], [selectName]: selectItem };
      this.setState({
        oneway: {
          ...this.state.oneway,
          [timeKey]: updatedTime,
        },
      });
    } else {
      const { roundtrip } = this.state;
      const key = `${destination}${timeKey}`;
      roundtrip[key] = { ...roundtrip[key], [selectName]: selectItem };
      this.setState({
        roundtrip,
      });
    }
  }

  onDateChanged(date, destination, typeTransfer, dateKey = 'dateSelected') {
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      this.setState({
        oneway: {
          ...this.state.oneway,
          [dateKey]: date,
        },
      });
    } else {
      const { roundtrip } = this.state;
      roundtrip[`${destination}${dateKey}`] = date;
      this.setState({
        roundtrip,
      });
    }
  }

  getTime(selectedTime) {
    return `${selectedTime.hour.name}:${selectedTime.minute.name} ${selectedTime.timeFormat.name}`;
  }

  // Converts a { hour, timeFormat } 12-hour selection into a 0-23 24-hour number.
  timeTo24Hour(selectedTime) {
    const hourNum = parseInt(selectedTime.hour.code, 10) % 12;
    return selectedTime.timeFormat.code === 'pm' ? hourNum + 12 : hourNum;
  }

  // Converts a 0-23 24-hour number back into { hourCode, timeFormat } for 12-hour display.
  hour24ToTimeFormat(hour24) {
    const timeFormat = hour24 >= 12 ? 'pm' : 'am';
    let hour12 = hour24 % 12;
    if (hour12 === 0) {
      hour12 = 12;
    }
    const hourCode = hour12 < 10 ? `0${hour12}` : `${hour12}`;
    return { hourCode, timeFormat };
  }

  // Business rule: pickup time is never user-editable.
  // - Arrival transfers (airport -> hotel): pickup is exactly the flight arrival time.
  // - Departure transfers (hotel -> airport): pickup is 4 hours before the flight departure time.
  // `dayOffset` tells callers whether that subtraction rolled back into the previous
  // calendar day (e.g. a 1:00 am flight => 9:00 pm pickup, the day before). We don't
  // send this to the backend (it only stores pickup TIME), it's only for display.
  getPickupTime(flightSelectedTime, isArrival) {
    if (isArrival) {
      return {
        ...flightSelectedTime,
        dayOffset: 0,
      };
    }
    const flightHour24 = this.timeTo24Hour(flightSelectedTime);
    const pickupHour24 = (((flightHour24 - 4) % 24) + 24) % 24;
    const dayOffset = flightHour24 - 4 < 0 ? -1 : 0;
    const { hourCode, timeFormat } = this.hour24ToTimeFormat(pickupHour24);
    return {
      hour: { name: hourCode, code: hourCode },
      minute: { ...flightSelectedTime.minute },
      timeFormat: { name: timeFormat, code: timeFormat },
      dayOffset,
    };
  }

  formatDate(date) {
    return date ? moment(date).format(DATE_MASK_PRINT) : ' - ';
  }

  deleteExtra() {
    const { cart, extra, roomId } = this.props;
    const extraToDelete = cart.cartHotel.rooms[roomId - 1].extras.find((ext) => ext.code === extra.extra_code);
    const data = {
      roomCartId: cart.cartHotel.rooms[roomId - 1].unique_id,
      extraUuId: extraToDelete.extra_uuid,
    };
    this.setState({ isSelectedExtra: true });
    this.props.dispatch(removeFreeModeExtra(data));
  }

  renderTransportationDetails({
    passengers, extra_name, arrivalFlight, arrivalTime, arrivalPickupTime,
    departureFlight = null, departureTime = null, departurePickupTime = null,
  }) {
    return (
      <div>
        <div style={{
          height: '1px', backgroundColor: '#000000', marginBottom: '10px', marginTop: '15px',
        }}></div>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          lineHeight: '1.5',
          fontFamily: 'Arial, sans-serif',
          fontSize: '14px',
          color: '#555',
        }}>
          <ul style={{
            listStyleType: 'disc', margin: 0, paddingLeft: '20px', width: '50%',
          }}>
            <li style={{ marginBottom: '10px' }}>{passengers} {this.context.t('Passengers')}</li>
            <li>
              <div>{extra_name}</div>
            </li>
          </ul>
          <ul style={{
            listStyleType: 'disc', margin: 0, paddingLeft: '20px', width: '50%',
          }}>
            <li style={{ wordWrap: 'break-word', maxWidth: '200px' }}>
              {this.context.t('Arrival Flight no.')}: {arrivalFlight}<br />
              {arrivalTime}<br />
              {arrivalPickupTime}
            </li>
            {departureFlight != null && departureTime != null
            && <li style={{ wordWrap: 'break-word', maxWidth: '200px' }}>
              {this.context.t('Departure Flight no.')}: {departureFlight}<br />
              {departureTime}<br />
              {departurePickupTime}
            </li>
            }
          </ul>
        </div>
      </div>
    );
  }

  renderTransferDetails(extra) {
    if (!extra.prices) {
      return null;
    }
    const {
      lang, chain, typeTransfer,
    } = this.props;
    const {
      oneway,
      roundtrip,
      paxSelected,
    } = this.state;
    //const added = this.isAdded();

    const totalPax = paxSelected.adults + paxSelected.childs + paxSelected.infants;
    //const currentAmount = extra.prices[currency.code].amount;
    if (typeTransfer === EXTRA_OPTIONAL_FIELDS.ONEWAY) {
      const isOnewayArrival = this.state.typeExtra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOHOTEL;
      const onewayPickupTime = this.getPickupTime(oneway.selectedTime, isOnewayArrival);
      const onewayPickupDate = oneway.dateSelected.clone().add(onewayPickupTime.dayOffset, 'days');
      return this.renderTransportationDetails({
        extra_name: this.getExtraName(extra),
        passengers: totalPax,
        arrivalFlight: `${oneway.airline} ${oneway.flight}`,
        arrivalTime: `AT: ${formatDate(oneway.dateSelected, lang, chain)} ${this.getTime(oneway.selectedTime)}`,
        arrivalPickupTime: `PT: ${formatDate(
          onewayPickupDate, lang, chain)} ${this.getTime(onewayPickupTime)}`,
      });
    }
    const arrivalPickupTime = this.getPickupTime(roundtrip.arrival_selectedTime, true);
    const departurePickupTime = this.getPickupTime(roundtrip.departure_selectedTime, false);
    const departurePickupDate = roundtrip.departure_dateSelected.clone().add(departurePickupTime.dayOffset, 'days');
    return this.renderTransportationDetails({
      extra_name: this.getExtraName(extra),
      passengers: totalPax,
      arrivalFlight: `${roundtrip.arrival_airline} ${roundtrip.arrival_flight}`,
      arrivalTime: `AT: ${this.formatDate(
        roundtrip.arrival_dateSelected)} ${this.getTime(roundtrip.arrival_selectedTime)}`,
      arrivalPickupTime: `PT: ${this.formatDate(
        roundtrip.arrival_dateSelected)} ${this.getTime(arrivalPickupTime)}`,
      departureFlight: `${roundtrip.departure_airline} ${roundtrip.departure_flight}`,
      departureTime: `DT: ${this.formatDate(
        roundtrip.departure_dateSelected)} ${this.getTime(roundtrip.departure_selectedTime)}`,
      departurePickupTime: `PT: ${this.formatDate(
        departurePickupDate)} ${this.getTime(departurePickupTime)}`,
    });
  }

  renderPriceDetail(extra, isExtraAdded = false) {
    if (!extra.prices) {
      return null;
    }
    const {
      currency, isCallCenterUser,
    } = this.props;
    const added = this.isAdded();
    //Pidieron que quieren ver los costos redondeados cuando la moneda no sea la de la reserva
    const minimumFractionDigits = 0;
    const maximumFractionDigits = 0;

    //const totalPax = paxSelected.adults + paxSelected.childs + paxSelected.infants;
    const currentAmount = extra.prices[currency.code].amount;
    return (
      <div className={`price-detail ${(!added && !isCallCenterUser) && 'w-4/4'}`}
        style={{ marginTop: isExtraAdded ? '15px' : '0' }}>
        <div className="price-detail__title">{this.context.t('Transportation cost')}:</div>
        <div className="extra-amounts">
          <div className="amount-price-block">
            <div className="amount-price pt-2">
              <span className="amount-price__currency">
                {formatCurrency(currentAmount, { ...currency, minimumFractionDigits, maximumFractionDigits })}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderExtraInfo(extra) {
    return (
      <div className="extra-info">
        <div className="extra-info__title text-capitalize">
          {this.getExtraName(extra)}
        </div>
        <div className="transferExtraDescription">
          {this.getExtraDescription(extra)}
        </div>
      </div>
    );
  }

  renderInfoFlight(extra, destination, typeTransfer, dateCheckInCheckOut) {
    const {
      checkIn,
      checkOut,
    } = this.props.cart.cartHotel.rooms[this.props.roomId - 1];
    const { isCallCenterUser } = this.props;
    const isArrival = dateCheckInCheckOut === EXTRA_ARRIVAL_OR_DEPARTURE_DATE.ARRIVAL;
    const isRoundtrip = typeTransfer === EXTRA_OPTIONAL_FIELDS.ROUNDTRIP;
    const dateInput = isArrival ? checkIn : checkOut;
    const paddingTop = !isCallCenterUser ? 'pt-5 xl:pt-0' : 'pt-5';

    // Labels are context-aware so the arrival vs. departure blocks of a roundtrip
    // (and the single block of a oneway) are never ambiguous.
    const sectionTitle = isArrival ? this.context.t('Arrival') : this.context.t('Departure');
    const flightDateLabel = isArrival ? this.context.t('Flight Arrival Date') : this.context.t('Flight Departure Date');
    const flightTimeLabel = isArrival ? this.context.t('Flight Arrival Time') : this.context.t('Flight Departure Time');

    const flightSelectedTime = this.state[typeTransfer][`${destination}selectedTime`];
    const pickupTime = this.getPickupTime(flightSelectedTime, isArrival);

    const { airlinesCatalog, airlinesLoading } = this.state;
    const selectedAirlineId = this.state[typeTransfer][`${destination}airline_id`];
    const selectedAirlineFromCatalog = airlinesCatalog.find(
      (airline) => String(airline.id) === String(selectedAirlineId),
    );
    const isOtherAirlineSelected = this.isOtherAirline(
      selectedAirlineFromCatalog ? selectedAirlineFromCatalog.name : '',
    );

    return (
      <React.Fragment>
        {isRoundtrip && (
          <div className={`px-2 font-bold uppercase tracking-wide text-sm text-gray-600
            border-b border-extra-grey pb-1 mb-2 ${isArrival ? 'mt-1' : 'mt-8'}`}>
            {sectionTitle}
          </div>
        )}
        <div className={`flex px-2 ${isCallCenterUser ? 'flex-wrap' : 'flex-col lg:flex-row'} ${paddingTop}`}>
          <label className={`flex lg:w-full ${isCallCenterUser && 'lg:w-2/4 justify-end pr-10 pb-5'}`}>
            <span className={`flex w-12 ${isCallCenterUser && 'w-12'}`}>{this.context.t('Airline')}</span>
            <select
              className='xl:mx-1 border-extra-grey text-center w-32'
              required
              disabled={airlinesLoading}
              value={selectedAirlineId || ''}
              onChange={(ev) => this.updateAirlineSelect(ev, destination, typeTransfer)}
            >
              <option value="" disabled>
                {airlinesLoading ? this.context.t('Loading airlines...') : this.context.t('Select an airline')}
              </option>
              {airlinesCatalog.map((airline) => (
                <option key={airline.id} value={airline.id}>{airline.name}</option>
              ))}
            </select>
          </label>
          <label className={isCallCenterUser ? 'sm:flex w-full justify-end pr-10' : 'lg:flex lg:w-1/4 justify-end'}>
            <span className={`${isCallCenterUser ? 'mx-1' : 'flex whitespace-nowrap'}`}>{this.context.t('Flight no.')}</span>
            <input
              className='lg:flex lg:justify-end border-extra-grey text-center w-32'
              type="text"
              required
              minLength={2}
              maxLength={80}
              value={this.state[typeTransfer][`${destination}flight`]}
              onChange={(ev) => this.updateFlight(ev, destination, typeTransfer)}
              />
          </label>
        </div>

        {/* Only shown when the catalog's catch-all "OTRA/OTHER" airline is selected:
            the real airline name isn't in SeekAndGo's catalog, so we ask for it here. */}
        {isOtherAirlineSelected && (
          <div className="px-2 pt-3">
            <label className="flex items-center w-full">
              <span className="w-28 flex-shrink-0">{this.context.t('Airline name')}</span>
              <input
                className='border-extra-grey text-center h-7 flex-1 max-w-[220px]'
                type="text"
                required
                minLength={2}
                maxLength={80}
                value={this.state[typeTransfer][`${destination}airline`]}
                onChange={(ev) => this.updateAirline(ev, destination, typeTransfer)}
              />
            </label>
          </div>
        )}

        {/* Flight date: read directly from the check-in / check-out of the reservation.
            Takes the full row so it always reads cleanly on its own. */}
        <div className={`px-2 pt-4 flex ${isCallCenterUser ? 'justify-center' : undefined}`}>
          <label className={`flex items-center w-full ${isCallCenterUser && 'justify-center'}`}>
            <span className="w-28 flex-shrink-0">{flightDateLabel}</span>
            <input
              className='border-extra-grey text-center h-7 flex-1 max-w-[220px]'
              type="date"
              required
              minLength={2}
              maxLength={80}
              value={dateInput}
              readOnly={true}
            />
          </label>
        </div>

        {/* Flight time & pickup time: side by side in two columns so it's clear the
            pickup time is a separate moment from the flight's own arrival/departure time. */}
        <div className={`px-2 pt-4 grid grid-cols-1 sm:grid-cols-2 gap-4
          ${isCallCenterUser ? 'w-full' : undefined}`}>
          <div className="flex flex-col">
            <span className="mb-1">{flightTimeLabel}</span>
            <TimePicker
              className={`flex flex-row flex-no-wrap content-end
              ${isCallCenterUser ? 'w-full' : undefined}`}
              selectedTime={this.state[typeTransfer][`${destination}selectedTime`]}
              roundtripSelector={typeTransfer}
              destination={destination}
              onChange={(selectName, selectItem, dest, typeT) => this.onChangeSelect(
                selectName, selectItem, dest, typeT, 'selectedTime',
              )}
              hasBorder={true}
            />
          </div>
          <div className="flex flex-col">
            <span className="mb-1">{this.context.t('Pickup Time')}</span>
            <input
              type="text"
              readOnly={true}
              className="border-extra-grey text-center h-7 w-32"
              value={this.getTime(pickupTime)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderExtraFields(extra) {
    const { typeTransfer, isCallCenterUser } = this.props;
    const { typeExtra } = this.state;
    const { ONEWAY, ROUNDTRIP } = EXTRA_OPTIONAL_FIELDS;
    const dateCheckInCheckOut = typeExtra === EXTRA_OPTIONAL_FIELDS.ONEWAYTOHOTEL
      ? EXTRA_ARRIVAL_OR_DEPARTURE_DATE.ARRIVAL : EXTRA_ARRIVAL_OR_DEPARTURE_DATE.DEPARTURE;
    return (
      <Fragment>
        <div className="extra-info flex flex-col sm:grid sm:grid-cols-10 sm:gap-4">
          <div className={isCallCenterUser ? 'col-span-2' : 'col-span-12'}>
            <PaxSelector
              extra={extra}
              currentPax={this.state.paxSelected}
              paxUpdated={this.paxUpdated}
              hasTitle={true}
            />
          </div>
        </div>
        <div className="extra-info flex flex-col sm:grid sm:grid-cols-10 sm:gap-4"
          style={typeTransfer === ONEWAY ? { marginTop: '-15px' } : {}}>
          <div className={`${isCallCenterUser ? 'col-span-8' : 'col-span-12'} flex flex-col sm:mt-0`}>
            {typeTransfer === ONEWAY
              && this.renderInfoFlight(extra, '', ONEWAY, dateCheckInCheckOut)}
            {typeTransfer === ROUNDTRIP
              && this.renderInfoFlight(extra, 'arrival_', ROUNDTRIP, EXTRA_ARRIVAL_OR_DEPARTURE_DATE.ARRIVAL)}
            {typeTransfer === ROUNDTRIP
              && this.renderInfoFlight(extra, 'departure_', ROUNDTRIP, EXTRA_ARRIVAL_OR_DEPARTURE_DATE.DEPARTURE)}
          </div>
        </div>
      </Fragment>
    );
  }

  renderSelectButton() {
    // For the buttons of the rooms that are not selected, we highlight them with a special style
    const { isCartUpdating, isCallCenterUser } = this.props;
    const isSelectedOne = isCartUpdating && this.state.isSelectedExtra;
    return (
      <button className={`btn btn-primary my-2 p-3 uppercase flex self-end ${!isCallCenterUser && 'sm:self-start'}`}
        style={{ width: '90%' }}
        type='submit' disabled={isCartUpdating}>
        {isSelectedOne ? this.context.t('Adding') : this.context.t('Add')}
      </button>
    );
  }

  renderEditButton() {
    // For the buttons of the rooms that are not selected, we highlight them with a special style
    const { isCartUpdating, isCallCenterUser } = this.props;
    const isSelectedOne = isCartUpdating && this.state.isSelectedExtra;
    return (
      <Btn className={`btn btn-primary p-3 mx-2 uppercase flex self-end ${!isCallCenterUser && 'sm:self-start'}`}
        disabled={isCartUpdating} onClick={() => this.deleteExtra()}>
          {isSelectedOne ? this.context.t('Editing') : this.context.t('Edit')}</Btn>
    );
  }

  formSubmit = (e) => {
    e.preventDefault();
    const { extra, availId, roomId } = this.props;
    const { selectedStatus, memberInfo } = this.props.loyalty;
    const { BECOME_MEMBER } = LOYALTY_STATUS;
    const isLoyalty = selectedStatus === BECOME_MEMBER || !!(memberInfo && memberInfo.accountHolder);
    this.setState({ isSelectedExtra: true });
    const data = {
      room_uuid: this.state.rooms[roomId - 1].unique_id,
      extra_code: extra.extra_code,
      avail_id: availId[roomId],
      days: this.formatDaysParam(),
      quantity: 1,
      additional_data: this.formExtraFields(),
      category: extra.category,
      loyalty: isLoyalty,
    };
    this.props.dispatch(addSelectedExtrasToCart(data));
    if (this.props.isCallCenterUser2 === false) {
      // Sólo mandamos a llamar al botón de continue cuando no sea call center
      // Porque cuando no es call center el botón de continue no está y siempre
      // está abierta esa sección de extras
      const shouldKeepExtrasSectionOpen = true;
      this.props.onClickContinue(shouldKeepExtrasSectionOpen);
    }
  }

  renderExtraForm(extra) {
    const { isCallCenterUser: isCC } = this.props;
    return (
      // eslint-disable-next-line react/no-string-refs
      <form ref="Extra" className="extra-card transfer" onSubmit={this.formSubmit}>
        <div className="extra-card__content2 flex flex-col sm:grid sm:grid-cols-10 sm:gap-2">
          <div className="card-content sm:col-span-7 flex-col transferExtraInfo">
            {this.renderExtraInfo(extra)}
            {this.renderExtraFields(extra)}
            {this.renderTransferDetails(extra)}
          </div>
          <div
            className={`card-content col-span-3 justify-between flex-col sm:flex-${isCC
              ? 'col' : 'row'} ${this.props.isMobile ? 'transferExtraPriceOuterMobile' : 'transferExtraPriceOuter'}`}
          >
            <div className={'transferExtraPrice'}>
              {this.renderPriceDetail(extra)}
              {this.renderSelectButton()}
            </div>
          </div>
        </div>
      </form>
    );
  }

  renderExtraAdded(extra) {
    return (
      <div className="extra-card transfer">
        <div
          className="
            extra-card__content2
            flex
            flex-col
            sm:grid
            sm:grid-cols-10
            sm:gap-2
            transferExtraCardSelectedPadding
          "
        >
          <div className="card-content col-span-9 flex-col">
            {this.renderExtraInfo(extra)}
            <br />
            {this.renderPriceDetail(extra)}
            {this.renderTransferDetails(extra)}
          </div>
          <div className="card-content col-span-1 flex-col sm:flex-row justify-end">
            {this.renderEditButton()}
          </div>
        </div>
        <div className="flex-col" style={{
          border: '1px solid #A0C85C',
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          'text-align': 'center',
          'background-color': '#A0C85C',
          'font-weight': 'bold',
          'font-size': '1.2rem',
        }}>
            {this.context.t('*Once the reservation is booked, please check your confirmation email to finish setting up your transportation.')}
        </div>
      </div>
    );
  }

  render() {
    const { extra, typeTransfer } = this.props;

    if (extra.type.filter((type) => type.type_extra.includes(typeTransfer)).length === 0) {
      return null;
    }
    const added = this.isAdded();

    return (
      <CSSTransition
        in={this.state.animateRoom}
        timeout={500}
        classNames={{ enter: 'heartbeat extra-tile' }}
        onExited={() => this.setState({ animateRoom: false })}
        key={extra.code}>
        {!added ? this.renderExtraForm(extra) : this.renderExtraAdded(extra)}
      </CSSTransition>
    );
  }
}

ExtraTransfer.propTypes = {
  extra: PropTypes.object.isRequired,
  typeTransfer: PropTypes.string.isRequired,
  roomId: PropTypes.string,
  onClickContinue: PropTypes.func.isRequired,
};

ExtraTransfer.defaultProps = {
  onShowRoomDetails: () => null,
};

ExtraTransfer.contextTypes = {
  t: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
};

export default connect(((state) => ({
  isCartUpdating: state.cart.isUpdating,
  cart: state.cart,
  lang: state.i18nState.lang,
  chain: state.bookingFormState.chain,
  checkIn: state.bookingFormState.checkIn,
  checkOut: state.bookingFormState.checkOut,
  distributions: state.bookingFormState.distributions,
  currency: state.booking.filterCurrency,
  isMobile: state.booking.device === DEVICES.MOBILE,
  availId: state.extras.extrasAvailId,
  isCallCenterUser: false, //state.session.user.role === CALL_CENTER_ROLE,
  isCallCenterUser2: state.session.user.role === CALL_CENTER_ROLE,
  loyalty: state.loyalty,
})))(ExtraTransfer);
